import { PreviousInsightDisplay } from '../UnitPerformanceInsightsCard';
import { type UseQueryResult } from '@tanstack/react-query';
import { type UnitPerformanceInsightsResponse } from '../../../../api/customEndpoints/fetchUnitPerformanceScores';
import { CardContent } from '../../../../components/ui/card';
import { Error } from '../../../../components/admin/error';
import { Loading } from '../../../../components/admin/loading';
import { useTranslate } from 'ra-core';

export function RecentInsightsCard({
  unitInsights,
}: {
  unitInsights: UseQueryResult<UnitPerformanceInsightsResponse>;
}) {
  const translate = useTranslate();

  return (
    <CardContent>
      <h2 className="text-xl font-semibold">
        {translate('moonstar.unitPerformance.insights.recent')}
      </h2>

      {unitInsights.isPending ? (
        <Loading />
      ) : unitInsights.isError ? (
        <Error
          error={unitInsights.error}
          resetErrorBoundary={() => void unitInsights.refetch()}
        />
      ) : unitInsights.data.previousInsights.length ? (
        <div className="mt-2 space-y-1">
          {unitInsights.data.previousInsights.map((insight) => (
            <PreviousInsightDisplay
              key={insight.id}
              date={insight.publishedOn ?? insight.createdOn}
              details={insight.content ?? ''}
            />
          ))}
        </div>
      ) : (
        <p>{translate('moonstar.unitPerformance.insights.recentEmpty')}</p>
      )}
    </CardContent>
  );
}
